import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const AwfulSmile = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 65 65"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}
            key='AwfulSmile'>
            { props.BgColor ?  <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor}/> : null }
            <path fillRule="evenodd" clipRule="evenodd" d="M32 4C16.536 4 4 16.536 4 32C4 47.464 16.536 60 32 60C47.464 60 60 47.464 60 32C60 16.536 47.464 4 32 4ZM0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill={props.color ? props.color : "black"}/>
            <path d="M22 47C22 47 24 42 32 42C40 42 42 47 42 47" stroke={props.color ? props.color : "black"} strokeWidth="2" strokeLinecap="round"/>
            <path d="M46.3716 18.0092L36.3716 22.0092L46.0005 28.0795" stroke={props.color ? props.color : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17.4213 18.0092L27.4213 22.0092L17.7924 28.0795" stroke={props.color ? props.color : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>     
        </SvgStyled>
    );
};

export default AwfulSmile;
